<template>
  <div class="layout-container">
    <div
      class="layout-page-container"
      :style="{ paddingBottom: isIphoneX ? '80px' : '60px' }"
      @scroll="handleScroll"
    >
      <Transition :name="transitionName">
        <keep-alive include="Home,Video">
          <router-view ref="routeContent" class="child-view" />
        </keep-alive>
      </Transition>
    </div>
    <NavigationBottom />
  </div>
</template>

<script>
import NavigationBottom from "@/components/NavigationBottom/index";
import { isIphoneX } from "@/utils/isIphoneX";

export default {
  name: "Layout",
  components: {
    NavigationBottom
  },
  data() {
    return {
      transitionName: "slide-left",
      isLoadingData: false,
      isIphoneX: isIphoneX()
    };
  },
  methods: {
    async handleScroll(event) {
      const element = event.srcElement;
      const scrollBottom =
        element.scrollHeight - element.scrollTop - element.clientHeight;
      if (scrollBottom < 50 && !this.isLoadingData) {
        this.isLoadingData = true;
        this.$refs.routeContent.handleScrollBottom &&
          (await this.$refs.routeContent.handleScrollBottom());
        this.isLoadingData = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.layout-container {
  .layout-page-container {
    position: relative;
    height: 100vh;
    width: 100%;
    padding-bottom: 60px;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }
}
</style>
